var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bae40b97-e368-4fb8-b54f-4915f82c4480",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vbl") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M94.23,69.1H50.61V65.64A3.56,3.56,0,0,0,47,62.08a3.52,3.52,0,0,0-1.77.48L19.45,77.47a3.55,3.55,0,0,0,0,6.16L45.27,98.54A3.52,3.52,0,0,0,47,99a3.56,3.56,0,0,0,3.57-3.56V92H94.23a4.47,4.47,0,0,0,4.46-4.46v-14A4.47,4.47,0,0,0,94.23,69.1Zm1.46,18.44A1.48,1.48,0,0,1,94.23,89H47.61v6.46A.57.57,0,0,1,47,96a.56.56,0,0,1-.27-.08L21,81a.52.52,0,0,1-.28-.48.51.51,0,0,1,.28-.48L46.77,65.16a.47.47,0,0,1,.27-.08.57.57,0,0,1,.57.56V72.1H94.23a1.48,1.48,0,0,1,1.46,1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.76,40.58,81.94,25.67a3.52,3.52,0,0,0-1.77-.48,3.56,3.56,0,0,0-3.57,3.56v3.46H33a4.47,4.47,0,0,0-4.45,4.46v14A4.47,4.47,0,0,0,33,55.11H76.6v3.46a3.56,3.56,0,0,0,3.57,3.56,3.52,3.52,0,0,0,1.77-.48l25.82-14.91A3.56,3.56,0,0,0,107.76,40.58Zm-1.5,3.56L80.44,59.05a.47.47,0,0,1-.27.08.57.57,0,0,1-.57-.56V52.11H33a1.47,1.47,0,0,1-1.45-1.46v-14A1.47,1.47,0,0,1,33,35.21H79.6V28.75a.57.57,0,0,1,.57-.56.56.56,0,0,1,.27.08l25.82,14.91a.52.52,0,0,1,.28.48A.51.51,0,0,1,106.26,44.14Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerExchange);
export default __webpack_public_path__ + "static/media/player-exchange.233607eef05f4052e6541c5ea1bfe915.svg";
export { ForwardRef as ReactComponent };